import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate' // 数据持久化

const store = createPinia()
store.use(
  createPersistedState({
    storage: {
      getItem: uni.getStorageSync,
      setItem: uni.setStorageSync,
    },
  }),
)

export default store

// 模块统一导出
export * from './modules/auth'
export * from './modules/coupon'
export * from './modules/admin'
export * from './modules/common'
export * from './modules/map'
export * from './modules/rental'
export * from './modules/tenant'
